import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgInstagramIcon from './svgs/InstagramIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var instagramIcon = (props => useIcon(SvgInstagramIcon, SvgInstagramIcon, props));

export { instagramIcon as default };
